class EntregaPorBairroBase {
    public bairro: string = '';
    public valorEntrega: number = 0;
    public tempoEntrega: number = 0;
    public id: string = '';
    public ativo: boolean = false;
}

export class EntregaPorBairroRequest extends EntregaPorBairroBase {
}

export class EntregaPorBairroReponse extends EntregaPorBairroBase {
}

export class EntregaPorBairroViewModel extends EntregaPorBairroBase {
    public excluindo: boolean = false;
    public emEdicao: boolean = false;
}